import { split } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { createHttpLink } from '@apollo/client/link/http';

export const getSplitLink = (primaryURI, secondaryURI) => {
  const lodgelinkAPI = createHttpLink({ uri: primaryURI });
  const lodgelinkAdminBFF = createHttpLink({ uri: secondaryURI });
  return split(
    ({ query }) => {
      const { kind = '', operation = '', name = { value: '' } } = getMainDefinition(query) ?? {};
      return (
        kind === 'OperationDefinition' &&
        ((operation === 'query' && name.value === 'QUERY_MARGINS') ||
          (operation === 'mutation' && ['CREATE_MARGINS', 'EDIT_MARGINS', 'DELETE_MARGINS'].includes(name.value)))
      );
    },
    lodgelinkAdminBFF,
    lodgelinkAPI
  );
};
